/** @format */

import type { SortModelItem } from "ag-grid-community";
import { TResponse } from "./app";

export type CustomerSortModel = SortModelItem[];
export type CustomerFilterModel = Record<string, Record<string, unknown>>;

export const CUSTOMER_OBJECT_TYPES = ["personal", "company"] as const;
export type CustomerObjectType = (typeof CUSTOMER_OBJECT_TYPES)[number];

export const CUSTOMER_TYPES = ["both", "customer", "supplier"] as const;
export type CustomerType = (typeof CUSTOMER_TYPES)[number];

export interface Customer {
  id: number;
  code: string;
  name: string;
   object_type: CustomerObjectType;
   type: CustomerType;
  phone?: string;
  email?: string;
  address?: string;
  created_at?: string;
  updated_at?: string;
}

export type CustomerForm = {
  code: string;
  name: string;
  object_type: CustomerObjectType;
  type: CustomerType;
  phone?: string;
  email?: string;
  address?: string;
};

export type CustomerUpdatePayload = CustomerForm & { id: number };

export type CustomerListResponse = TResponse<Customer[]>;
export type CustomerDetailResponse = TResponse<Customer>;

export type CustomerQuery = {
  page?: number;
  pageSize?: number;
  sortModel?: CustomerSortModel;
  filterModel?: CustomerFilterModel;
  search?: string;
};
